import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=20878305"
import script from "./LayoutContent.vue?vue&type=script&lang=ts"
export * from "./LayoutContent.vue?vue&type=script&lang=ts"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=20878305&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports